import React from 'react';
import { T } from '../../../../common/locale/translate';

const rating_description = rating => {
  let rates = {};
  switch (true) {
    case !rating:
      rates = { description: T('no_reviews'), class: 'no-data' };
      break;
    case rating <= 6:
      rates = { description: '', class: 'no-rating' };
      break;
    case rating < 8:
      rates = { description: T('good'), class: 'good' };
      break;
    case rating < 8.5:
      rates = { description: T('very-good'), class: 'very-good' };
      break;
    case rating <= 9:
      rates = { description: T('excellent'), class: 'excellent' };
      break;
    case rating < 9.5:
      rates = { description: T('splendid'), class: 'splendid' };
      break;
    case rating <= 10:
      rates = { description: T('magnificent'), class: 'magnificent' };
      break;
    default:
      rates = { description: '', class: 'no-rating' };
  }
  return rates;
};

const Rating = props => {
  const rating = rating_description(props.rating);
  return (
    <div className={`rating ${rating.class}`}>
      <div className="rating-icon">
        <i className="fa fa-hand-o-right" />
      </div>
      <div className="rating-element">
        <span className="rating-number">
          {`${props.rating ? props.rating : '- '}`}
          <span>/10</span>
        </span>
        <span className="rating-description">{rating.description}</span>
      </div>
    </div>
  );
};

export default Rating;



// WEBPACK FOOTER //
// ./app/javascript/common/components/hotel-rating.js